// NPM Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "@revvsales/components";

import withRbac from "../../../app/withRbac";

// Actions Imports
import ProductActions from "../../../actions/ProductActions";

// Internal Imports
import { PERMISSIONS } from "../../../constants";

// Destructuring
const { togglePopUp } = ProductActions;

class ProductsBar extends Component {
  _togglePopUp = flag => {
    this.props.togglePopUp(flag);
  };

  render() {
    const { filterTxt, onFilterChange } = this.props;
    const AddProductBtn = withRbac(() => (
      <Button
        className="productsbar-additem"
        id="productsbar-additem"
        data-testid="productsbar-additem"
        type="button"
        onClick={() => this._togglePopUp(true)}
        data-test="productbar-add-new-product-btn">
        Add new product
      </Button>
    ));
    return (
      <div className="productsbar-wrapper">
        <div className="productsbar-search">
          <i className="productsbar-searchicon">
            <FontAwesomeIcon icon={["far", "search"]} />
          </i>
          <Input
            className="productsbar-input"
            placeholder="Search products"
            value={filterTxt}
            onChange={onFilterChange}
            data-test="productbar-filtertxt-input"
          />
        </div>
        <AddProductBtn permission={PERMISSIONS.PRODUCTS.CREATE_PRODUCTS} />
      </div>
    );
  }
}

ProductsBar.propTypes = {
  // Actions
  togglePopUp: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  togglePopUp,
};

export default connect(
  null,
  mapDispatchToProps,
)(ProductsBar);



// WEBPACK FOOTER //
// ./src/components/ControlBar/ProductsBar/index.js